export default "__VITE_ASSET__bee3869d__"